function timeAgo(input) {
    const date = input instanceof Date ? input : new Date(input);

    // Invalid date
    if (isNaN(date)) return '';

    const now = new Date();
    const diffMs = now - date;
    const seconds = Math.floor(diffMs / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours   = Math.floor(minutes / 60);
    const day = Math.floor(hours / 24);

    if (seconds < 60) return 'just now';
    if (minutes < 60) return `${minutes} min ago`;
    if (hours < 24)   return `${hours} ${hours  === 1 ? 'hour' : 'hours'} ago`;;
    if (day < 7)      return `${day} ${day === 1 ? 'day' : 'days'} ago`;

    // Fallback to date (e.g. 2 Jun or 2 Jun 2024 if year is different)
    const showYear = date.getFullYear() !== now.getFullYear();
    const formatter = new Intl.DateTimeFormat('en', {
      day: 'numeric',
      month: 'short',
      ...(showYear && { year: 'numeric' })
    });

    return formatter.format(date);
  }


// function timeAgo(input, opts = {}) {
//     const date = input instanceof Date ? input : new Date(input);

//     // Invalid date
//     if (isNaN(date)) return '';

//     const now = new Date();
//     const diffMs = now - date;

//     const sec = Math.floor(diffMs / 1000);
//     const min = Math.floor(sec / 60);
//     const hr = Math.floor(min / 60);
//     const day = Math.floor(hr / 24);

//     const { locale = 'en' } = opts;

//     const pluralize = (value, unit) => {
//         const rtf = new Intl.RelativeTimeFormat(locale, { numeric: 'auto' });
//         return rtf.format(-value, unit);
//     };

//     if (sec < 60) return pluralize(0, 'second');
//     if (min < 60) return pluralize(min, 'minute');
//     if (hr < 24) return pluralize(hr, 'hour');
//     if (day < 7) return pluralize(day, 'day');

//     // > 7 days: calendar date format
//     const fmt = new Intl.DateTimeFormat(locale, {
//         day: 'numeric',
//         month: 'short',
//         ...(date.getFullYear() !== now.getFullYear() && { year: 'numeric' })
//     });

//     return fmt.format(date);
// }



export { timeAgo };
